<svelte:options customElement={{ tag: "kalender-freigeben", shadow: "none" }} />

<script lang="ts">
  import { onMount } from "svelte";

  interface Freigaben {
    id?: number;
    jahr: number;
    monat: number;
    freigegeben: boolean;
  }

  let ready: boolean = $state(false);
  // Array der 12 Monate (von 1 bis 12)
  const monate: string[] = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12"
  ];
  let ausgewählteMonate: string[] = $state([]);
  let freigegebeneMonate: Freigaben[] = $state([]);
  // Initialisiere die Checkboxen-Status (alle auf false)
  let selectedJahrStr = $state(new Date().getFullYear().toString());
  let whileSave: boolean = $state(false);
  let möglicheJahre: string[] = $derived([
    (parseInt(selectedJahrStr) - 1).toString(),
    parseInt(selectedJahrStr).toString(),
    (parseInt(selectedJahrStr) + 1).toString()
  ]);

  onMount(async () => {
    freigegebeneMonate = await GetKalenderFreigaben();
    ausgewählteMonate = freigegebeneMonate.map((x) => x.monat.toString());
    ready = true;
  });

  async function GetKalenderFreigaben(): Promise<Freigaben[]> {
    let response = await fetch(
      `calendarstuff.php?kalenderFreigabe&jahr=${selectedJahrStr}`
    );
    if (!response.ok) {
      alert("Fehler beim Laden der Kalenderfreigaben");
      return [];
    }
    return await response.json();
  }

  async function SetKalenderFreigabe() {
    let selMonths = ausgewählteMonate.join(",");
    let response = await fetch("calendarstuff.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: new URLSearchParams({
        kalenderFreigabe: "",
        monate: selMonths,
        jahr: selectedJahrStr
      }),
      cache: "no-cache"
    });
    if (!response.ok) {
      alert("Fehler beim Speichern der Kalenderfreigaben");
      return;
    }

    alert("Kalenderfreigaben gespeichert");
  }
</script>

{#if ready == true}
  <div class="well well-sm">
    <legend>Kalender öffentlich auf Hauptseite freigeben</legend>
    <div id="kalenderFreigabe">
      {#each monate as monat, index}
        <input
          type="checkbox"
          id="kalenderFreigabeMonatCheck{index}"
          class="kalenderFreigabeMonatCheck"
          bind:group={ausgewählteMonate}
          value={monat}
          checked={freigegebeneMonate.some(
            (f) =>
              f.monat === index + 1 && f.jahr.toString() === selectedJahrStr
          )}
        />
        <label
          for="kalenderFreigabeMonatCheck{index}"
          style="margin-right: 20px;"
        >
          {monat}
        </label>
      {/each}
      <br /><br />
      Jahr:
      <select
        bind:value={selectedJahrStr}
        onchange={async () => {
          freigegebeneMonate = await GetKalenderFreigaben();
        }}
      >
        {#each möglicheJahre as jahr}
          <option>{jahr}</option>
        {/each}
      </select>
      <br /><br />
      <button
        id="buttonKalenderFreigabe"
        class="btn"
        class:btn-primary={!whileSave}
        class:btn-warning={whileSave}
        onclick={() => {
          SetKalenderFreigabe();
        }}
      >
        Ausgewählte Kalender freigeben
      </button>
    </div>
  </div>
{/if}
